var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGood = function SvgGood(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 .5a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-shadow",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#96af8b",
    d: "M9 0a9 9 0 1 0 9 9 9 9 0 0 0-9-9",
    className: "icon-background"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15.11 6.81-5.66 5.66-1.66 1.66a.4.4 0 0 1-.28.11.4.4 0 0 1-.27-.11L2.89 9.78a.4.4 0 0 1-.11-.28.4.4 0 0 1 .11-.27l1.39-1.38a.34.34 0 0 1 .12-.09h.15a.4.4 0 0 1 .15 0 .4.4 0 0 1 .13.09l2.69 2.68 5.65-5.65a.4.4 0 0 1 .13-.09.4.4 0 0 1 .15 0 .4.4 0 0 1 .15 0 .34.34 0 0 1 .12.09l1.39 1.38a.4.4 0 0 1 .08.13.3.3 0 0 1 0 .15.4.4 0 0 1 0 .15.5.5 0 0 1-.08.12",
    className: "icon-component-shadow",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.11 6.31 9.45 12l-1.66 1.63a.4.4 0 0 1-.28.11.4.4 0 0 1-.27-.11L2.89 9.28A.4.4 0 0 1 2.78 9a.4.4 0 0 1 .11-.27l1.39-1.38a.34.34 0 0 1 .12-.09h.15a.4.4 0 0 1 .15 0 .4.4 0 0 1 .13.09L7.52 10l5.65-5.65a.4.4 0 0 1 .13-.09.4.4 0 0 1 .15 0 .4.4 0 0 1 .15 0 .34.34 0 0 1 .12.09l1.39 1.38a.4.4 0 0 1 .08.13.3.3 0 0 1 0 .15.4.4 0 0 1 0 .15.5.5 0 0 1-.08.15",
    className: "icon-component"
  })));
};
export default SvgGood;